export default {
  name: 'Home',
  components: {}
}